import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5.315 12.355h5.468c.668 0 1.21.542 1.21 1.21l-.001 5.467a1.21 1.21 0 01-2.42-.001l.001-4.256H5.315a1.21 1.21 0 010-2.42zM13.218 3.759c.668 0 1.21.541 1.21 1.209l.001 4.257h4.255a1.21 1.21 0 010 2.42h-5.465a1.21 1.21 0 01-1.21-1.209l-.001-5.467c0-.668.542-1.21 1.21-1.21z"
}), 'Reduce');